var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.30163 8.10625L11.3524 13.0645C11.5195 13.2286 11.6031 13.4279 11.6031 13.6623C11.6031 13.8967 11.5195 14.096 11.3524 14.2601C11.1852 14.4242 10.9822 14.5063 10.7434 14.5063C10.5046 14.5063 10.3016 14.4242 10.1345 14.2601L4.77924 9.00295C4.6479 8.87402 4.55238 8.73336 4.49268 8.58098C4.43298 8.42859 4.40312 8.27035 4.40312 8.10625C4.40312 7.94215 4.43298 7.78391 4.49268 7.63152C4.55238 7.47914 4.6479 7.33848 4.77924 7.20955L10.1345 1.9524C10.3016 1.7883 10.5046 1.70625 10.7434 1.70625C10.9822 1.70625 11.1852 1.7883 11.3524 1.9524C11.5195 2.11651 11.6031 2.31577 11.6031 2.55021C11.6031 2.78464 11.5195 2.98391 11.3524 3.14801L6.30163 8.10625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationChevronLeft);
export default __webpack_public_path__ + "static/media/Pagination_chevron_left.07c80089a0e8f152d50417b97f45961e.svg";
export { ForwardRef as ReactComponent };